import script from "./TableViewControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableViewControls.vue?vue&type=script&setup=true&lang=ts"

import "./TableViewControls.vue?vue&type=style&index=0&id=7fb96f4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fb96f4c"]])

export default __exports__